import React from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

interface EditActionNumberDialogProps {
  visible: boolean;
  onHide: () => void;
  actionNumber: string;
  onActionNumberChange: (value: string) => void;
  onApprove: () => void;
  loading: boolean;
}

export const EditActionNumberDialog: React.FC<EditActionNumberDialogProps> = ({
  visible,
  onHide,
  actionNumber,
  onActionNumberChange,
  onApprove,
  loading,
}) => {
  return (
    <Dialog
      header="עריכת קוד פעולה"
      visible={visible}
      style={{ width: '400px', direction: 'rtl' }}
      onHide={onHide}
      modal
    >
      <div style={{ padding: '20px 0' }}>
        <label
          htmlFor="actionNumber"
          style={{ display: 'block', marginBottom: '8px' }}
        >
          קוד פעולה (עד 30 תווים):
        </label>
        <InputText
          id="actionNumber"
          value={actionNumber}
          onChange={(e) => onActionNumberChange(e.target.value)}
          maxLength={30}
          style={{ width: '100%' }}
          placeholder="הזן קוד פעולה"
        />
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
        <Button
          label="ביטול"
          onClick={onHide}
          className="p-button-text"
          disabled={loading}
        />
        <Button label="אישור" onClick={onApprove} loading={loading} />
      </div>
    </Dialog>
  );
};
